"use client";
import { jsxs as e, jsx as l } from "react/jsx-runtime";
const c = ({
  title: i,
  titleId: a,
  desc: d,
  descId: h,
  ...t
}) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-tg",
    viewBox: "0 0 640 480",
    "aria-labelledby": a,
    "aria-describedby": h,
    ...t,
    children: [
      d ? /* @__PURE__ */ l("desc", { id: h, children: d }) : null,
      i ? /* @__PURE__ */ l("title", { id: a, children: i }) : null,
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "tg-a", children: /* @__PURE__ */ l("path", { fillOpacity: 0.7, d: "M0 0h682.7v512H0z" }) }) }),
      /* @__PURE__ */ e("g", { fillRule: "evenodd", clipPath: "url(#tg-a)", transform: "scale(.9375)", children: [
        /* @__PURE__ */ l("path", { fill: "#ffe300", d: "M0 0h767.6v512H0z" }),
        /* @__PURE__ */ l("path", { fill: "#118600", d: "M0 208.1h767.6V311H0zM0 .2h767.6v102.9H0z" }),
        /* @__PURE__ */ l("path", { fill: "#d80000", d: "M0 .3h306.5v310.6H0z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#fff",
            d: "M134.4 128.4c0-.8 18.9-53 18.9-53l17 52.2s57.4 1.7 57.4.8-45.3 34.3-45.3 34.3 21.4 60 20.5 58.2c-.8-1.7-49.6-36-49.6-36s-49.7 34.3-48.8 34.3c.8 0 18.8-56.5 18.8-56.5l-44.5-33.4z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "#118600", d: "M0 409.2h767.6V512H0z" })
      ] })
    ]
  }
);
export {
  c as default
};
